/**
 * 阿里云文件处理
 * 官方文档：https://help.aliyun.com/document_detail/383952.html
 */
// import OSS from "ali-oss";
import $axios from "@/utils/axios";
import uuid from "uuid/v4";

import COS from 'cos-js-sdk-v5';

// 以下配置不能随意修改
export const REGION = "ap-guangzhou";
export const BUCKET = process.env.VUE_APP_OSS_BUCKET;
export const AUTH_DIR = "upload"; // 文件上传后保存的根路径
export const OSS_FILE_DOMAIN = process.env.VUE_APP_OSS_FILE; // 文件访问域名, 注意，与 BUCKET 是互相匹配的

/**
 * 获取上传用的权限信息, 目前3600秒后过期
 * @returns {Object} { 
 *  accessKeyId,
    accessKeySecret,
    stsToken, }
 */
async function fetchStsToken() {
  let { data } = await $axios.post(
    `/${process.env.VUE_APP_PROXY_DING_OA}/aliOss/getStsToken`,
    {
      session: `${Math.random()}`,
    },
    { type: "form", uselsmyAccount: true }
  );

  console.log('fetchStsToken: ', data);

  return {
    SecretId: data.accessKeyId,
    SecretKey: data.accessKeySecret,
    SecurityToken: data.securityToken,
  };
}

/**
 * 创建一个OSS实例
 * @returns
 */
async function createCosClient() {

  let { SecretId, SecretKey, SecurityToken } = await fetchStsToken();

  let options = {
    // region: REGION,
    // bucket: BUCKET,
    SecretId,
    SecretKey,
    SecurityToken,

    refreshSTSTokenInterval: 30 * 60 * 1000, // 刷新token间隔,10分钟
    refreshSTSToken: fetchStsToken, // 刷新token
  }

  let OSSIns = new COS(options);

  return OSSIns;
}

/**
 * 分片文件上传（默认用这个）
 * @param {*} file
 * @param {Function} options.onProgress 监听上传进度，0 ~ 100
 * @param {String} options.uploadFilePath 上传到阿里云的文件路径，不传则自动生成
 * @param {Function} options.customClient 自定义OSS实例，不传则使用默认的
 */
export async function uploadByOSS(file, options = {}) {
  console.log('options: ', options);
  console.log('file: ', file);

  let { onProgress, uploadFilePath, customClient } = options

  const client = customClient ? await customClient() : await createCosClient();
  console.log('uploadByOSS client: ', client);
  console.log('uploadFilePath || createFilePath(file): ', uploadFilePath || createFilePath(file));

  const key = uploadFilePath || createFilePath(file);
  let uploadRes = await client.uploadFile({
    Bucket: BUCKET,
    Region: REGION,
    Key: key,
    Body: file,
    // 设置并发上传的分片数量。
    // parallel: 4,
    // 设置分片大小。默认值为1 MB，最小值为100 KB。
    SliceSize: 1024 * 1024,
    // headers,
    // 自定义元数据，通过HeadObject接口可以获取Object的元数据。
    // meta: { year: 2020, people: "test" },
    mime: file.type,
    // 获取分片上传进度、断点和返回值。
    onProgress: (progressData) => {
      onProgress && onProgress(Math.round(progressData.percent * 100))
    },
  });

  console.log("uploadRes", uploadRes);

  let params = {
    aliOssBucketName: uploadRes.Bucket || BUCKET,
    aliOssETag: JSON.parse(uploadRes.ETag),
    aliOssLocation: key,
    aliOssKey: key,
    name: file.name,
    sizes: file.size || 0,
    suffixtt: `.${file.name.split(".").pop()}`,
    url: `${OSS_FILE_DOMAIN}${key}`
  }

  let res = await $axios.post(
    `/${process.env.VUE_APP_PROXY_DING_OA}/attachment/saveByAliOss`,
    [
      params
    ],
    { type: "json", uselsmyAccount: true }
  );

  return {
    ...res.data[0],
    ...params
  };
}

/**
 * 通过保存在后端的 附件对象，获取文件的临时预览和下载地址
 * @param {*} attachment 
 * 	{
      "aliOssLocation": "", // 阿里云-位置
      "id": "",
      "name": "", // 文件名
      "path": "",
      "sizes": "",
      "suffixtt": "", // 文件后缀
      "url": ""
    }
 */
    export async function getOSSFileUrl(attachment) {
      // console.log('attachment: ', attachment);
      // if (attachment.url) {
      //   return attachment.url;
      // }

      // if (attachment.aliOssKey) {
      //   return `${OSS_FILE_DOMAIN}${attachment.aliOssKey}`;
      // }

      // console.warn("传入的附件对象没有包含阿里云文件信息。");
      // return;

      if (!attachment.aliOssKey && !attachment.path) {
        if (!attachment.url) {
          console.warn("传入的附件对象没有key信息和url信息。");
          return;
        }

        // 尝试获取path作为Key信息
        attachment['aliOssKey'] = attachment.url?.split(process.env.VUE_APP_OSS_FILE)?.[1] || '';
        
        if (!attachment.aliOssKey) {
          return attachment.url;
        }
      }
    
      const client = await createCosClient();
    
      const url = client.getObjectUrl({
        Bucket: BUCKET,
        Region: REGION,
        Key: attachment.aliOssKey || attachment.path,
        Sign: true,
        Expires: 3600, // 单位秒
      });

      const downloadUrl = url +
        (url.indexOf('?') > -1 ? '&' : '?') +
        'response-content-disposition=attachment;filename="' + encodeURIComponent(attachment.name) + '"';

      return downloadUrl;
    }

// /**
//  * 创建一个OSS实例
//  * @returns
//  */
// async function createClient() {

//   let { accessKeyId, accessKeySecret, stsToken } = await fetchStsToken();

//   let options = {
//     region: REGION,
//     bucket: BUCKET,
//     accessKeyId,
//     accessKeySecret,
//     stsToken,

//     // refreshSTSTokenInterval: 30 * 60 * 1000, // 刷新token间隔,10分钟
//     // refreshSTSToken: fetchStsToken, // 刷新token
//   }

//   let OSSIns = new COS(options);

//   return OSSIns;
// }

// /**
//  * 分片文件上传（默认用这个）
//  * @param {*} file
//  * @param {Function} options.onProgress 监听上传进度，0 ~ 100
//  * @param {String} options.uploadFilePath 上传到阿里云的文件路径，不传则自动生成
//  * @param {Function} options.customClient 自定义OSS实例，不传则使用默认的
//  */
// export async function uploadByOSS(file, options = {}) {

//   let { onProgress, uploadFilePath, customClient } = options

//   const client = customClient ? await customClient() : await createCosClient();
//   console.log('uploadByOSS client: ', client);

//   let uploadRes = await client.multipartUpload(uploadFilePath || createFilePath(file), file, {
//     // 获取分片上传进度、断点和返回值。
//     progress: (p, cpt, res) => {
//       onProgress && onProgress(Math.round(p * 100))
//     },
//     // 设置并发上传的分片数量。
//     parallel: 4,
//     // 设置分片大小。默认值为1 MB，最小值为100 KB。
//     partSize: 1024 * 1024,
//     // headers,
//     // 自定义元数据，通过HeadObject接口可以获取Object的元数据。
//     // meta: { year: 2020, people: "test" },
//     mime: file.type,
//   });

//   console.log("uploadRes", uploadRes);

//   let params = {
//     aliOssBucketName: uploadRes.bucket,
//     aliOssETag: JSON.parse(uploadRes.etag),
//     aliOssLocation: uploadRes.name,
//     name: file.name,
//     sizes: file.size,
//     suffixtt: `.${file.name.split(".").pop()}`,
//     url: `${OSS_FILE_DOMAIN}${uploadRes.name}`
//   }

//   let res = await $axios.post(
//     `/${process.env.VUE_APP_PROXY_DING_OA}/attachment/saveByAliOss`,
//     [
//       params
//     ],
//     { type: "json", uselsmyAccount: true }
//   );

//   return {
//     ...res.data[0],
//     ...params
//   };
// }

// /**
//  * 通过保存在后端的 附件对象，获取文件的临时预览和下载地址
//  * @param {*} attachment 
//  * 	{
//       "aliOssLocation": "", // 阿里云-位置
//       "id": "",
//       "name": "", // 文件名
//       "path": "",
//       "sizes": "",
//       "suffixtt": "", // 文件后缀
//       "url": ""
//     }
//  */
// export async function getOSSFileUrl(attachment) {
//   if (!attachment.aliOssLocation) {
//     console.warn("传入的附件对象没有包含阿里云文件信息。");
//     return;
//   }

//   const client = await createCosClient();
//   console.log('client: ', client);

//   const url = client.signatureUrl(attachment.aliOssLocation, {
//     response: {
//       "content-disposition": `attachment; filename=${encodeURIComponent(
//         attachment.name
//       )}`,
//     },
//   });

//   return url;
// }

/**
 * 生成在阿里云中储存的路径地址，通过当前日期拼接出
 * @param {*} file
 * @returns
 */
function createFilePath(file) {
  let suffix = file.name.split(".").pop();

  let now = new Date();

  return `${AUTH_DIR}/${now.getFullYear()}/${now.getMonth() +
    1}/${now.getDate()}/${uuid()}.${suffix}`;
}

/**
 * 简单上传(不建议使用，统一使用)
 * @param {*} file
 */
export async function simpleUpload(file) {
  try {
    const client = await createCosClient();
    console.log('client: ', client);

    let res = await client.put(createFilePath(file), file);

    console.log("simpleUpload", res);
  } catch (error) {
    console.log(error);
  }
}
